import { render, staticRenderFns } from "./febvideoflow.vue?vue&type=template&id=77dde0bf&lang=pug&"
import script from "./febvideoflow.vue?vue&type=script&lang=js&"
export * from "./febvideoflow.vue?vue&type=script&lang=js&"
import style0 from "./febvideoflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports